import { render, staticRenderFns } from "./ResultSection.vue?vue&type=template&id=710b4038&scoped=true"
import script from "./ResultSection.ts?vue&type=script&lang=ts&external"
export * from "./ResultSection.ts?vue&type=script&lang=ts&external"
import style0 from "./ResultSection.vue?vue&type=style&index=0&id=710b4038&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b4038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710b4038')) {
      api.createRecord('710b4038', component.options)
    } else {
      api.reload('710b4038', component.options)
    }
    module.hot.accept("./ResultSection.vue?vue&type=template&id=710b4038&scoped=true", function () {
      api.rerender('710b4038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/ResultSection/ResultSection.vue"
export default component.exports